import { computed as o } from "vue";
function u(n) {
  return { responses: o(() => {
    const e = [];
    return n && Object.entries(n).forEach(([c, t]) => {
      var r;
      e.push({
        name: c,
        description: t.description,
        content: t.content,
        headers: t.headers,
        schema: (r = t.content) == null ? void 0 : r.schema
      });
    }), e;
  }) };
}
export {
  u as useResponses
};
